import Icon from '@components/shared/Icon'
import styles from 'styles/ButtonSpinner.module.css'

export default function ButtonSpinner () {
    return <span className={styles.spin}>
        <Icon>autorenew</Icon>
    </span>
}
